import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const guestUserOrderApi = createApi({
  reducerPath: 'guestUserOrderApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://fftestservice.sarsetech.com/',
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('admin_token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set(
        'authkey', '7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3'
      );
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['GuestOrder'],
  endpoints: (build) => ({
    listGuestOrders: build.query({
      query: () => ({
        url: 'user/adminGuestListOrders',
        method: 'POST',
        body: {},
      }),
      providesTags: ['GuestOrder'],
    }),
  }),
});

export const {
  useListGuestOrdersQuery,
} = guestUserOrderApi;